var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated"},[_c('v-client-table',{staticClass:"w-100",attrs:{"columns":_vm.columns,"data":_vm.data,"options":_vm.options,"theme":_vm.theme,"id":"schedule-grinding-table"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }